{
  "BANNER": {
    "TITLE": "Connect with the right kind of care",
    "DESCRIPTION": "We take care of your every day and large healthcare needs. Take care of yourself and we will take care of the rest. Get your first month membership in just $29.99.",
    "BTNTEXT": "Get Started Now"
  },
  "FEATURE": {
    "TITLE": "Featured in"
  },
  "BENEFITS": {
    "TITLE": "Benefits you get",
    "DESCRIPTION": "Membership that puts control back in your hands, with a community behind you ",
    "BOX1": {
      "TITLE": "Peace of Mind",
      "DESCRIPTION": " Our members have full transparency and control over their medical decisions, with no long-term commitments."
    },
    "BOX2": {
      "TITLE": "Simple Model",
      "DESCRIPTION": "Discounted direct-pay rates for routine Everyday Care. Option to add HealthShare for large medical needs like ER visits, hospitalizations, pregnancy, etc."
    },
    "BOX3": {
      "TITLE": "No Restrictions",
      "DESCRIPTION": "No annual or lifetime caps on services. Nationwide access including global protection while traveling"
    }
  },
  "FEELBETTER": {
    "MINI_TITLE": "What we treat?",
    "TITLE": "How can we help you feel better?",
    "BOX1": {
      "TITLE": "Virtual Urgent Care",
      "DESCRIPTION": "Free 24/7 access to a doctor without the wait or cost of office visits."
    },
    "BOX2": {
      "TITLE": "Mental Health",
      "DESCRIPTION": "Free sessions with certified counselors to assist with the stressors of life."
    },
    "BOX3": {
      "TITLE": "Medications",
      "DESCRIPTION": "Up to 400 generic medications at no cost"
    },
    "BOX4": {
      "TITLE": "Complete Care",
      "DESCRIPTION": "Regardless of your medical needs, we have services to address all of them. "
    }
  },
  "BENIFITSMEMBERSHIP": {
    "MINI_TITLE": "How it Works",
    "TITLE": "Benefits of our membership",
    "BENIFIT1": "Free 24/7 Telemedicine access to a doctor, and mental health counselors",
    "BENIFIT2": "Nationwide community of direct-pay providers, across all aspects of healthcare",
    "BENIFIT3": "Simple app and workflows for everyone, not just some medical experts",
    "BENIFIT4": "No long term commitments with monthly plans to our member only community",
    "BENIFIT5": "Transparent pricing without need for approvals for all healthcare needs",
    "BENIFIT6": "24/7 customer support to assist with any questions"
  },
  "MONTHLYMEMBERSHIP": {
    "TITLE": "Get your monthly membership for only $29.99",
    "DESCRIPTION": "Comprehensive healthcare without the high costs of premiums and complexities of insurance" ,
    "BTNTEXT": "Get Started" 
  },
  "BLOG":{
    "MINI_TITLE": "Join the community",
    "TITLE": "Partner with us to provide meaningful benefits with control and transparency"
  },
  "TESTIMONIALS":{
    "MINI_TITLE": "Testimonials",
    "TITLE": "See how we've helped our members by hearing their stories."
  },
  "HELP":{
    "MINI_TITLE": "How can we help?",
    "TITLE": "Talk to us or explore our FAQ page",
    "BOX1": {
      "TITLE": "Talk to customer support",
      "DESCRIPTION": "Chat or speak to one of our member support representatives, 24/7. We strive to provide the very best care of all of our members."
    },
    "BOX2": {
      "TITLE": "Visit FAQ page",
      "DESCRIPTION": " We have answered many questions that you may have, and some that you may not have thought of yet! Connect with us if we can help in any way."
    }
  },
      "FAQS": {
        "MINI_TITLE": "How it works",
        "TITLE1": "Frequently",
        "TITLE2": "Asked Questions",
        "DESCRIPTION": "Need help? Reach out to our 24/7 customer support at  <a class='phone' href='tel:8449694325'>844-969-4325</a> and get the assistance you need.",
        "LINK": "Visit Faqs Page",
        "FAQ_LIST":   [
          {
            "title": "What is the difference between WoW Plus & health insurance?",
            "description": "WoW Plus provides steeply discounted access to medical providers across the full spectrum of healthcare. It is not insurance but a direct pay network where our members pay the provider at the time of service. In reality, everyone is “self-pay” because with insurance copays, deductibles and coinsurance, people who have not met their out-of-pocket maximums may pay more than with the WoW Health direct pay solution. WoW Plus brings control and transparency so our members know what they will pay, and don’t need any approvals to get the care they need–if you can pay for it, you can get the care that you and your doctor deem appropriate!"
          },
          {
            "title": "Why do I need WoW Health?",
            "description": "Whataburger Team Members are eligible for medical plan benefits when you work an average of 30-hours per week over a 12-month period. Whataburger is providing you access to WoW Health as a discounted health care option. WoW Health provides a cost-effective way to take care of your medical needs like office visits, medications, labs, and much more! We have built WoW Health to be an alternative to insurance by giving you control and transparency"
          },
          {
            "title": "Is there a penalty for not having health insurance?",
            "description": "As of 2019, the federal individual mandate is no longer in effect, which means there is no federal tax penalty for not having an insurance plan. You should talk to your tax accountant to find out if you have any state requirements"
          },
          {
            "title": "Can I add family members?",
            "description": "Yes! You can add up to 8 family members under the age of 26 to any of the WoW Health plans. Though family members are part of the same plan, every member over age 18 has their own WoW Health account. Members under the age of 18 have a WoW Health account that can be accessed from the parent account interface. We strongly recommend that everyone download the WoW Health app which provides the best experience."
          },
          {
            "title": "When can I start using my WoW Health membership?",
            "description": "Your WoW Health membership will be ready for use 1 week from the time of enrollment, and will renew every month. For example, if you sign up on August 5th, your plan will be ready for use on August 12th, and you will be charged on the 12th of every month thereafter."
          },
          {
            "title": "Can I cancel my membership?",
            "description": "Yes, you can cancel your membership from your WoW Health membership anytime and will end on the last day of the paid benefit period. For example, your membership will cancel the day of your monthly renewal date"
          },
          {
            "title": "Can I use WoW Health with insurance, Medicare or Medicaid?",
            "description": "Yes, you can get WoW Health as a supplement because it is a membership based non-insurance healthcare access. You do not use your insurance or Medicare/Medicaid cards when using WoW Health."
          }
        ]
    }
,
  "language": "en"
}